import React from "react";
import {messages} from "../common/Translations";
import SelectInterests from "./SelectInterests";
import {Field} from 'redux-form';

let InterestField = props => {
    return (
        <div className="form-group row">
            <label className="col-sm-2 col-form-label">
                <b>{ props.label }</b>
            </label>
            <div className="col-sm-10">
                <Field
                    type="select"
                    name={props.name}
                    component={SelectInterests}
                    options={props.options}
                    placeholder={props.placeholder}
                />
            </div>
        </div>
    );
};

export default InterestField;


// WEBPACK FOOTER //
// ./web/src/components/interests/InterestField.jsx